__turbopack_context__.v({
  "checklistblock": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock",
  "checklistblock--finished": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock--finished",
  "checklistblock__animation--in": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__animation--in",
  "checklistblock__container": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__container",
  "checklistblock__container--finished": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__container--finished",
  "checklistblock__header": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__header",
  "checklistblock__header--picked": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__header--picked",
  "checklistblock__header__question": "ChecklistBlock-module-sass-module__iBpzgG__checklistblock__header__question",
});
